module.exports = __webpack_public_path__ + "static/media/rikke.f8c258c3.mp3";